import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function TheUnfilteredJourney() {
  return <section id="the-unfiltered-journey" className="dark bg-background text-foreground group relative flex h-[80vh] min-h-[600px] w-full items-center justify-center overflow-hidden">
      {}
      <Link to="/AboutMePage" className="absolute inset-0 z-20 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" aria-label="Read The Story">
        <span className="sr-only">Read The Story</span>
      </Link>

      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1550663/img/mike_at_work_cinematic.png)] bg-cover bg-center transition-transform duration-1000 ease-out group-hover:scale-105 will-change-transform" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[hsl(0,0%,7%)] opacity-90" aria-hidden="true" />

      {}
      <div className="relative z-10 flex items-center gap-4 text-white pointer-events-none">
        <h2 className="font-sans text-5xl font-bold tracking-tight md:text-7xl lg:text-8xl">
          Read The Story
        </h2>
        <ArrowRight className="h-10 w-10 transition-transform duration-300 ease-out group-hover:translate-x-2 md:h-16 md:w-16" strokeWidth={2} />
      </div>
    </section>;
}